/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { WochenplanDto } from '../../models/wochenplan-dto';

export interface GetWochenplaene$Plain$Params {
  onlySoftDeletes?: boolean;
}

export function getWochenplaene$Plain(http: HttpClient, rootUrl: string, params?: GetWochenplaene$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<WochenplanDto>>> {
  const rb = new RequestBuilder(rootUrl, getWochenplaene$Plain.PATH, 'get');
  if (params) {
    rb.query('onlySoftDeletes', params.onlySoftDeletes, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<WochenplanDto>>;
    })
  );
}

getWochenplaene$Plain.PATH = '/v1/wochenplaene';
